export default "__VITE_ASSET__CizZkWdf__"